import MapsLocationIcon from '@/components/Icons/MapsLocationIcon';
import Switch from '@/components/Switch/index';
import { isGamChannel } from '@/constants/forecaster';
import { useAppSelector } from '@/store/hooks';
import { selectForecastGeoOptions } from '@/store/selectors/forecaster.selectors';
import { FormLabel } from '@mui/material';
import Paper from '@mui/material/Paper';
import PropTypes from 'prop-types';
import { useEffect, useMemo } from 'react';
import { Controller, useFormContext } from 'react-hook-form';
import GeoSearch from './GeoSearch';

const Geographic = ({ currentChannel }) => {
  const { control, getValues, setValue } = useFormContext();

  const { geoOptions, geoOptionsRequestId } = useAppSelector(selectForecastGeoOptions(currentChannel));

  const loadingGeo = useMemo(() => !!geoOptionsRequestId, [geoOptionsRequestId]);
  // GAM forecasting doesn't support address-radius (geo-fence) targeting.
  const showAddressRadius = !isGamChannel(currentChannel);

  useEffect(() => {
    if (!isGamChannel(currentChannel)) return;
    if (getValues('isGeoFencingSearch') || getValues('geoFence')) {
      setValue('isGeoFencingSearch', false);
      setValue('geoFence', null);
    }
  }, [currentChannel, getValues, setValue]);

  return (
    <Paper className='col-span-3 p-4 print:p-[10px]'>
      <div className='flex flex-col gap-2'>
        <div className='flex justify-between items-center relative'>
          <div className='flex gap-1 items-center'>
            <MapsLocationIcon />
            <p className='ml-2 text-[#2E2C34] text-[18px] font-semibold'>Geo Selection</p>
          </div>
          {showAddressRadius && (
            <div className='flex pr-10 gap-2 items-center'>
              <FormLabel htmlFor='isGeoFencingSearch' sx={{ margin: 0, fontWeight: 600 }}>
                Address Radius
              </FormLabel>
              <Controller
                name='isGeoFencingSearch'
                control={control}
                defaultValue={false}
                render={({ field }) => <Switch {...field} id='isGeoFencingSearch' checked={!!field.value} />}
              />
            </div>
          )}
        </div>
        <GeoSearch options={geoOptions} loading={loadingGeo} currentChannel={currentChannel} />
      </div>
    </Paper>
  );
};

Geographic.propTypes = {
  currentChannel: PropTypes.string,
};

export default Geographic;
